import { provideHttpClient, withXhr } from '@angular/common/http';
import { ApplicationConfig, inject, LOCALE_ID, provideAppInitializer } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { EnvService } from '@ic2/ic2-lib';
import { firstValueFrom } from 'rxjs';
import { routes } from './app.routes';
import { AuthService } from './tools/auth.service';
import { Config } from './tools/Config';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr' },
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top', anchorScrolling: 'enabled' })),
    provideHttpClient(withXhr()),
    provideAppInitializer(() => {
      const envService = inject(EnvService<Config>);
      const authService = inject(AuthService);

      console.log('loading env for', window.location.hostname);

      if (['localhost', '192.168.1.1', 'maison.deepneel.fr'].includes(window.location.hostname)) {
        envService.confUrl = 'http://' + window.location.hostname + ':8080/front.config.json';
      } else {
        envService.confUrl = window.location.protocol + '//api.' + window.location.hostname + '/front.config.json';
      }

      return new Promise<void>((resolve, reject) => {
        const timeout = setTimeout(() => {
          reject(new Error('Time'));
        }, 3000);

        firstValueFrom(envService.load(new Config()))
          .then(() => {
            clearTimeout(timeout);
            resolve();
          })
          .catch(() => {
            clearTimeout(timeout);
            reject(new Error('Down'));
          });
      });
    }),
  ],
};
